var _defs, _g, _path, _path2, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalSuccessCouponValidated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #003a5d;\n      }\n\n      .cls-2 {\n        fill: #007da5;\n      }\n\n      .cls-3 {\n        fill: #ffc557;\n      }\n\n      .cls-4 {\n        fill: #918c94;\n      }\n\n      .cls-5 {\n        fill: #90d5ac;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m663.55,389.52c0,44.35-35.94,80.32-80.3,80.32s-80.34-35.96-80.34-80.32,35.98-80.32,80.34-80.32,80.3,35.96,80.3,80.32h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "570.03 293.8 583.25 238.09 596.47 293.8 570.03 293.8 570.03 293.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "538.07 304.09 531.47 247.23 562.95 295.04 538.07 304.09 538.07 304.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "511.6 324.7 485.92 273.52 531.84 307.69 511.6 324.7 511.6 324.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "493.74 353.11 452.1 313.81 506.96 330.2 493.74 353.11 493.74 353.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "486.68 385.92 434.11 363.23 491.29 359.87 486.68 385.92 486.68 385.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "491.29 419.17 434.11 415.82 486.68 393.11 491.29 419.17 491.29 419.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "506.96 448.84 452.1 465.24 493.74 425.93 506.96 448.84 506.96 448.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "531.84 471.35 485.92 505.52 511.6 454.35 531.84 471.35 531.84 471.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "562.95 484 531.47 531.82 538.07 474.95 562.95 484 562.95 484"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "596.47 485.24 583.25 540.95 570 485.25 596.47 485.24 596.47 485.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "628.41 474.95 635.03 531.82 603.56 484 628.41 474.95 628.41 474.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "654.91 454.35 680.58 505.52 634.63 471.36 654.91 454.35 654.91 454.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "672.76 425.93 714.41 465.23 659.55 448.84 672.76 425.93 672.76 425.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "679.82 393.12 732.36 415.81 675.22 419.17 679.82 393.12 679.82 393.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "675.22 359.88 732.36 363.22 679.82 385.93 675.22 359.88 675.22 359.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "659.55 330.21 714.41 313.8 672.76 353.11 659.55 330.21 659.55 330.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "634.63 307.69 680.58 273.51 654.91 324.7 634.63 307.69 634.63 307.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "603.56 295.05 635.03 247.22 628.44 304.09 603.56 295.05 603.56 295.05"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m736.26,719.89l105.57-177.12v-167.21c0-11.75-9.55-21.31-21.29-21.31s-21.34,9.56-21.34,21.31v132l-114.7,118.66-21.6-20.88,61.31-63.43c7.66-8.99,7.17-22.6-1.34-30.99-8.9-8.75-23.3-8.68-32.1.18l-90.24,90.81v155.12h135.74v-37.15h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m570.48,757.04v-155.12l-90.24-90.81c-8.8-8.86-23.2-8.94-32.1-.18-8.52,8.39-9.03,22-1.34,30.99l61.31,63.43-21.6,20.88-114.73-118.66v-132c0-11.75-9.55-21.31-21.31-21.31s-21.32,9.56-21.32,21.31v167.21l105.6,177.12v37.15h135.74Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m434.02,267.36c0,19-15.39,34.4-34.39,34.4s-34.41-15.4-34.41-34.4,15.41-34.4,34.41-34.4,34.39,15.4,34.39,34.4h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "393.97 226.36 399.63 202.51 405.29 226.36 393.97 226.36 393.97 226.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "380.28 230.77 377.45 206.42 390.93 226.9 380.28 230.77 380.28 230.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "368.94 239.6 357.95 217.68 377.61 232.31 368.94 239.6 368.94 239.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "361.29 251.77 343.46 234.93 366.96 241.95 361.29 251.77 361.29 251.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "358.27 265.82 335.76 256.1 360.24 254.66 358.27 265.82 358.27 265.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "360.24 280.06 335.76 278.62 358.27 268.9 360.24 280.06 360.24 280.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "366.96 292.76 343.46 299.78 361.29 282.95 366.96 292.76 366.96 292.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "377.61 302.4 357.95 317.04 368.94 295.12 377.61 302.4 377.61 302.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "390.93 307.82 377.45 328.3 380.28 303.94 390.93 307.82 390.93 307.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "405.29 308.35 399.63 332.21 393.95 308.36 405.29 308.35 405.29 308.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "418.97 303.94 421.81 328.3 408.33 307.82 418.97 303.94 418.97 303.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "430.32 295.12 441.31 317.04 421.64 302.41 430.32 295.12 430.32 295.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "437.97 282.95 455.8 299.78 432.3 292.76 437.97 282.95 437.97 282.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "440.99 268.9 463.49 278.62 439.02 280.06 440.99 268.9 440.99 268.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "439.02 254.66 463.49 256.09 440.99 265.82 439.02 254.66 439.02 254.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "432.3 241.96 455.8 234.93 437.97 251.77 432.3 241.96 432.3 241.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "421.64 232.31 441.31 217.68 430.32 239.6 421.64 232.31 421.64 232.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "408.33 226.9 421.81 206.41 418.98 230.77 408.33 226.9 408.33 226.9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m807.53,261.58c0,20.21-16.38,36.59-36.59,36.59s-36.6-16.38-36.6-36.59,16.39-36.59,36.6-36.59,36.59,16.38,36.59,36.59h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "764.92 217.97 770.95 192.59 776.97 217.97 764.92 217.97 764.92 217.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "750.36 222.66 747.35 196.75 761.69 218.54 750.36 222.66 750.36 222.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "738.3 232.05 726.6 208.73 747.52 224.3 738.3 232.05 738.3 232.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "730.16 244.99 711.19 227.08 736.18 234.55 730.16 244.99 730.16 244.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "726.95 259.94 702.99 249.6 729.04 248.07 726.95 259.94 726.95 259.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "729.04 275.09 702.99 273.56 726.95 263.22 729.04 275.09 729.04 275.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "736.18 288.61 711.19 296.08 730.16 278.17 736.18 288.61 736.18 288.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "747.52 298.87 726.6 314.44 738.3 291.12 747.52 298.87 747.52 298.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "761.69 304.63 747.35 326.42 750.36 300.51 761.69 304.63 761.69 304.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "776.97 305.2 770.95 330.58 764.91 305.2 776.97 305.2 776.97 305.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "791.52 300.51 794.54 326.42 780.2 304.63 791.52 300.51 791.52 300.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "803.59 291.12 815.29 314.44 794.36 298.87 803.59 291.12 803.59 291.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "811.73 278.17 830.7 296.08 805.71 288.61 811.73 278.17 811.73 278.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "814.95 263.22 838.88 273.56 812.85 275.09 814.95 263.22 814.95 263.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "812.85 248.07 838.88 249.6 814.95 259.95 812.85 248.07 812.85 248.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "805.71 234.56 830.7 227.08 811.73 244.99 805.71 234.56 805.71 234.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "794.36 224.3 815.29 208.73 803.59 232.05 794.36 224.3 794.36 224.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "780.2 218.54 794.54 196.75 791.53 222.66 780.2 218.54 780.2 218.54"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m606.99,146.23c0,20.21-16.38,36.59-36.59,36.59s-36.6-16.38-36.6-36.59,16.39-36.59,36.6-36.59,36.59,16.38,36.59,36.59h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "564.38 102.62 570.4 77.24 576.43 102.62 564.38 102.62 564.38 102.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "549.81 107.31 546.81 81.4 561.15 103.19 549.81 107.31 549.81 107.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "537.75 116.7 526.06 93.38 546.98 108.95 537.75 116.7 537.75 116.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "529.62 129.65 510.64 111.74 535.64 119.21 529.62 129.65 529.62 129.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "526.4 144.6 502.45 134.25 528.5 132.72 526.4 144.6 526.4 144.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "528.5 159.74 502.45 158.22 526.4 147.87 528.5 159.74 528.5 159.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "535.64 173.26 510.64 180.73 529.62 162.82 535.64 173.26 535.64 173.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "546.98 183.52 526.06 199.09 537.75 175.77 546.98 183.52 546.98 183.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "561.15 189.28 546.81 211.07 549.81 185.16 561.15 189.28 561.15 189.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "576.43 189.85 570.4 215.23 564.37 189.85 576.43 189.85 576.43 189.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "590.98 185.16 594 211.07 579.66 189.28 590.98 185.16 590.98 185.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "603.05 175.77 614.75 199.09 593.81 183.52 603.05 175.77 603.05 175.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "611.19 162.82 630.16 180.73 605.17 173.26 611.19 162.82 611.19 162.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "614.4 147.87 638.34 158.21 612.3 159.75 614.4 147.87 614.4 147.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "612.3 132.73 638.34 134.25 614.4 144.6 612.3 132.73 612.3 132.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "605.17 119.21 630.16 111.73 611.19 129.65 605.17 119.21 605.17 119.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "593.81 108.95 614.75 93.38 603.05 116.7 593.81 108.95 593.81 108.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "579.66 103.19 594 81.4 590.99 107.31 579.66 103.19 579.66 103.19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSuccessCouponValidated);
export default __webpack_public_path__ + "static/media/ModalSuccessCouponValidated.e910f28f0e8dff4f0711f9d3cce11df9.svg";
export { ForwardRef as ReactComponent };